import { ReactNode } from 'react';
import { Box, CloseButton } from '@chakra-ui/react';
import { Button, Colors, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const toastContentStyle = {
  background: Colors.ForestGreen900,
  borderRadius: '4px',
  color: Colors.White,
  padding: 'padding_8',
};

const undoButtonStyle = {
  height: 'auto',
};

type TUndoToastProps = {
  onClickUndo: () => void;
  onClose: () => void;
  children: ReactNode;
};

const UndoToast = ({ onClickUndo, onClose, children }: TUndoToastProps) => {
  return (
    <FlexRow sx={toastContentStyle}>
      <CloseButton onClick={onClose} />
      <Box>{children}</Box>
      <Button variant="unstyled" onClick={onClickUndo} sx={undoButtonStyle}>
        <Text.BodyBold>Undo</Text.BodyBold>
      </Button>
    </FlexRow>
  );
};

export default UndoToast;
